"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _antd = require("antd");

var _Upload = require("./Upload.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * 上傳組建可拖移
 */
var AntDragger = _antd.Upload.Dragger;

var Upload = function Upload(_ref) {
  var fileList = _ref.fileList,
      _ref$message = _ref.message,
      message = _ref$message === void 0 ? "" : _ref$message,
      _ref$limit = _ref.limit,
      limit = _ref$limit === void 0 ? 999 : _ref$limit,
      acceptFileType = _ref.acceptFileType,
      prompt = _ref.prompt,
      multiple = _ref.multiple,
      onChange = _ref.onChange;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      sendFile = _useState2[0],
      setFileSend = _useState2[1];

  var propsUpload = {
    beforeUpload: function beforeUpload() {
      return false;
    },
    onChange: function onChange(info) {
      var listFiles = info.fileList;
      var newArrayFiles = listFiles.map(function (file) {
        return file.originFileObj ? file.originFileObj : file;
      });
      setFileSend(newArrayFiles);
    },
    multiple: multiple,
    showUploadList: true,
    accept: acceptFileType,
    maxCount: multiple ? limit : 1,
    fileList: fileList
  };
  (0, _react.useEffect)(function () {
    var nextSendFile = sendFile.filter(function (item, index) {
      return sendFile.indexOf(item) === index;
    });
    onChange && onChange(nextSendFile);
  }, [sendFile]);
  return /*#__PURE__*/_react.default.createElement(_Upload.UiUpload, null, /*#__PURE__*/_react.default.createElement(AntDragger, _extends({
    name: "file"
  }, propsUpload), /*#__PURE__*/_react.default.createElement("p", {
    className: "ant-upload-drag-icon"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons"
  }, "cloud_upload")), /*#__PURE__*/_react.default.createElement("p", {
    className: "text"
  }, "\u4E0A\u50B3\u6A94\u6848"), /*#__PURE__*/_react.default.createElement("p", {
    className: "prompt"
  }, prompt)), message !== "" && /*#__PURE__*/_react.default.createElement("div", {
    className: "message"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons"
  }, "cancel"), message));
};

var _default = Upload;
exports.default = _default;
Upload.propTypes = {
  fileList: _propTypes.default.array,
  message: _propTypes.default.string,
  limit: _propTypes.default.number,
  acceptFileType: _propTypes.default.string,
  prompt: _propTypes.default.element,
  multiple: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  deleteFile: _propTypes.default.func
};